// extracted by mini-css-extract-plugin
export default {"editHeader":"edit-hub-module__editHeader___2CDLZ","closeButton":"edit-hub-module__closeButton___gjJf0"};